<script lang="ts">
  import gsap from 'gsap';

  interface HeroSliderProps {
    onchange?: (value: number) => void;
  }

  const { onchange }: HeroSliderProps = $props();

  let inputValue = $state(0);
  let displayValue = $state(0);

  let tween: gsap.core.Tween | null = null;

  const handleFillPercent = $derived(((displayValue + 1) / 2) * 100);

  const thumbTranslateY = $derived(() => {
    const normalized = handleFillPercent / 100;
    const distanceFromCenter = Math.abs(normalized - 0.5) * 2;
    return 50 + distanceFromCenter * distanceFromCenter * (window.innerWidth > 480 ? 30 : 10);
  });

  const animateToValue = (target: number): void => {
    if (tween) tween.kill();
    const obj = { v: displayValue };
    tween = gsap.to(obj, {
      v: target,
      duration: 0.4,
      ease: 'power2.out',
      onUpdate: () => {
        displayValue = obj.v;
        onchange?.(displayValue);
      },
    });
  };

  const onInput = (e: Event): void => {
    const target = e.currentTarget as HTMLInputElement;
    inputValue = Number(target.value);
    animateToValue(inputValue);
  };
</script>

<div
  class="relative z-2 mx-auto max-w-[calc(100svw-48px)] touch-none portrait:w-[calc(var(--vh)*60)] sm:portrait:w-[60svh] landscape:w-[60svh]"
>
  <div
    class="pointer-events-none absolute bottom-0 left-1/2 h-44 -translate-x-1/2 bg-[url('https://yellow-b-global.b-cdn.net/production/the-architect/images/hero-slider-background.png')] bg-contain bg-bottom bg-no-repeat portrait:w-[calc(var(--vh)*70)] portrait:max-w-[calc(100svw+48px)] sm:portrait:w-[70svh] landscape:w-[70svh]"
  ></div>
  <div
    class="slider-track relative h-1.5 w-full"
    style="--thumb-pct: {handleFillPercent}; --thumb-y: {thumbTranslateY()}%"
  >
    <input
      class="absolute top-1/2 left-0 m-0 h-[96px] w-full -translate-y-1/2 cursor-pointer appearance-none opacity-0"
      type="range"
      min="-1"
      max="1"
      step="0.01"
      value={inputValue}
      oninput={onInput}
      aria-label="Hero slider"
    />
  </div>
</div>

<style>
  @reference '$src/css/main.css';

  .slider-track::before,
  .slider-track::after {
    @apply pointer-events-none absolute top-1/2 h-8 w-8 origin-top-left rounded-full bg-white ease-in-out md:h-10 md:w-10;
    content: '';
    transition: scale 0.15s ease;
    left: calc(20px + (100% - 40px) * var(--thumb-pct, 50%) * 0.01);
    transform: translate(-50%, calc(var(--thumb-y, -50%) * -1));
  }

  .slider-track::before {
    @apply h-20 w-20 bg-transparent md:h-16 md:w-16;
  }

  .slider-track:has(input:hover)::after,
  .slider-track:has(input:active)::after {
    scale: 1.1;
  }
</style>
